// eslint-disable-next-line @nx/enforce-module-boundaries
import { buildSharedStorageItemName, sharedStorage } from '@ocx-app/modules/shared-storage/shared.storage';

const STORAGE_VERSION = 1;
const LAST_VISITED_URL_KEY = `vroom-last-visited-url-v${STORAGE_VERSION}`;

export const getLastVisitedUrl = (params: { membershipId: string }) =>
  sharedStorage.getItem<string>(buildSharedStorageItemName(params.membershipId, LAST_VISITED_URL_KEY));

export const setLastVisitedUrl = (params: { membershipId: string; url: string }) =>
  sharedStorage.setItem<string>(buildSharedStorageItemName(params.membershipId, LAST_VISITED_URL_KEY), params.url);
